module.exports = __webpack_public_path__ + "img/lamina-packetgrup.6670b480.jpg";